// extracted by mini-css-extract-plugin
export var center = "gridOneCol-module--center--42b32";
export var content = "gridOneCol-module--content--af948";
export var full = "gridOneCol-module--full--14a85";
export var gray = "gridOneCol-module--gray--a302c";
export var left = "gridOneCol-module--left--34dfb";
export var noBorder = "gridOneCol-module--noBorder--34c85";
export var painted = "gridOneCol-module--painted--bdcd5";
export var small = "gridOneCol-module--small--46cce";
export var wrapper = "gridOneCol-module--wrapper--4f0d8";